import React from 'react';
import { Overlay, OverlayText, SpinningIcon } from '../../GlobalStyles';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

interface LoadingOverlayProps {
    message: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({message = "Loading..."}) => (
    <Overlay>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <SpinningIcon icon={faSpinner} size="2x" />
            <OverlayText>{message}</OverlayText>
        </div>
    </Overlay>
);

export default LoadingOverlay;